import { useEffect, useState } from "react";


function Input({ handleText, handleSource, langs, text }) {

    const [count, setCount] = useState(0)

    // localStorage character count

    useEffect(() => {
        const storedCharacterCount = localStorage.getItem('characterCount');
        const date = localStorage.getItem('lastDate')

        const today = new Date();
        const todayString = today.toDateString();

        if (todayString !== date) {

            localStorage.setItem('characterCount', '0');
            console.log(todayString, date)
        }

        if (storedCharacterCount) {
            const char = document.getElementById("textinput").value
            console.log(storedCharacterCount)
            setCount(+storedCharacterCount + char.length)
            console.log(count)
        }


    }, [text]);

    const limit = 16

    return (

        <>

            <select value={langs && langs[0]} type="text" onChange={handleSource}>
                <option value="">Válassz nyelvet</option>
                <option value="felismer">Felismer</option>
                <option value="en">Angol</option>
                <option value="zh">Kínai</option>
                <option value="es">Spanyol</option>
                <option value="ru">Orosz</option>
                <option value="fr">Francia</option>
                <option value="pt">Portugál</option>
                <option value="de">Német</option>
                <option value="it">Olasz</option>
                <option value="ja">Japán</option>
                <option value="nl">Holland</option>
                <option value="pl">Lengyel</option>
                <option value="uk">Ukrán</option>
                <option value="tr">Török</option>
                <option value="hr">Horvát</option>
                <option value="ro">Román</option>
                <option value="cs">Cseh</option>
                <option value="ko">Koreai</option>
                <option value="hu">Magyar</option>
                <option value="sk">Szlovák</option>
                <option value="el">Görög</option>
                <option value="sl">Szlovén</option>
                <option value="sv">Svéd</option>
                <option value="da">Dán</option>
                <option value="fi">Finn</option>
                <option value="th">Thai</option>
                <option value="no">Norvég</option>
                <option value="he">Héber</option>
                <option value="ar">Arab</option>
                <option value="bg">Bolgár</option>
                <option value="sq">Albán</option>
                <option value="vi">Vietnámi</option>
                <option value="la">Latin</option>
            </select>
            <div style={{ position: "relative" }}>
                <textarea disabled={count >= limit} id="textinput" onChange={handleText} value={text} maxLength="1000">

                </textarea>
                { count < limit ? <div className="remaining">{text ? text.length : 0} / 1,000</div> : <div className="reached">Elérted a napi maximumot</div> }
               
            </div>
        </>

    )
}

export default Input;